import axios from "axios";
import authHeader from "./auth-header";
import ErrorService from "./error.service";
import UserService from "./user.service";
import AdminService from "./admin.service";
import BaseChartService from "./echarts/base.chart.service";
import Vue from "vue";

import moment from "moment-timezone";
Vue.prototype.moment = moment;

const BASE_URL = AdminService.getBaseUrl();
const API_SURVEY_DESIGN_URL = BASE_URL + "/api/v1/survey-design";


class ValuePlayerService extends BaseChartService {
  async getValuePlayerSignalMapping(surveyId, clientTimePeriodId, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("surveyId", surveyId);
    params.append("clientTimePeriodId", clientTimePeriodId);
    params.append("userId", UserService.getUserId());
    await axios
      .post(API_SURVEY_DESIGN_URL + "/get-value-player-signal-mapping", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("ValuePlayerService.getValuePlayerSignalMapping", error, "survey-designer", chartApp);
      });
  }

  async saveValuePlayers(valuePlayerNodes, valuePlayerMappings, surveyId, callback, chartApp) {
    const params = new URLSearchParams();
    params.append("valuePlayerNodesObject", JSON.stringify(valuePlayerNodes));
    params.append("valuePlayerMappingsObject", JSON.stringify(valuePlayerMappings));
    params.append("userId", UserService.getUserId());
    params.append("surveyId", surveyId);
    await axios
      .post(API_SURVEY_DESIGN_URL + "/save-value-players", params, { headers: await authHeader() })
      .then(response => callback(response))
      .catch(error => {
        error.message += ErrorService.mergeError(error.response);
        ErrorService.processError("ValuePlayerService.saveValuePlayers", error, "survey-designer", chartApp);
      });
    }
    async getValuePlayerNodes(surveyId, callback, chartApp) {
      const params = new URLSearchParams();
      params.append("userId", UserService.getUserId());
      params.append("surveyId", surveyId);
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-value-player-nodes", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValuePlayerService.getValuePlayerNodes", error, "survey-designer", chartApp);
        });
    }
    async getAllValuePlayerIcons(callback, chartApp) {
      const params = new URLSearchParams();
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-all-value-player-icons", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValuePlayerService.getAllValuePlayerIcons", error, "survey-designer", chartApp);
        });
    }
    async getAllValuePlayerMappingTypes(callback, chartApp) {
      const params = new URLSearchParams();
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-all-value-player-mapping-types", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValuePlayerService.getAllValuePlayerMappingTypes", error, "survey-designer", chartApp);
        });
    }
    async getValuePlayerMappingData(surveyId, callback, chartApp) {
      const params = new URLSearchParams();
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-value-player-mapping-data", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValuePlayerService.getValuePlayerMappingData", error, "survey-designer", chartApp);
        });
    }

    async getValuePlayerChartAttributes(surveyId, callback, chartApp) {
      const params = new URLSearchParams();
      params.append("surveyId", surveyId);
      params.append("userId", UserService.getUserId());
      await axios
        .post(API_SURVEY_DESIGN_URL + "/get-value-player-chart-attributes", params, { headers: await authHeader() })
        .then(response => callback(response))
        .catch(error => {
          error.message += ErrorService.mergeError(error.response);
          ErrorService.processError("ValuePlayerService.getValuePlayerChartAttributes", error, "survey-designer", chartApp);
        });
    }

    async copyValuePlayers(sourceSurveyCode, targetSurveyGroupId, callback, panelApp) {
      if (typeof sourceSurveyCode != "undefined" && typeof targetSurveyGroupId != "undefined") {
        const params = new URLSearchParams();
        params.append("sourceSurveyCode", sourceSurveyCode);
        params.append("targetSurveyGroupId", targetSurveyGroupId);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_SURVEY_DESIGN_URL + "/copy-value-players", params, { headers: await authHeader() })
          .then(response => {
              callback(response)
            })
            .catch(error => {
              error.message += ErrorService.mergeError(error.response);
              ErrorService.processError("ValuePlayerService.copyValuePlayers", error, "admin", panelApp);
            });

      }
    }
  }

export default new ValuePlayerService();
